import React, { FC, useEffect, useState, memo } from "react";
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface NumberInputProps {
    label: string
    value: number | string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    defaultValue?: number | string
    helperText?: string
}

const NumberInput: FC<NumberInputProps> = ({ label, value, onChange, required = false, defaultValue, helperText }) => {

    const [initilized, setInitilized] = useState(false)
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    const handleNumberChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1 && value.startsWith('0')) {
            e.target.value = value.replace(/^0+/, '');
        }
        onChange(e);
    }, [onChange]);

    useEffect(() => {
        if (defaultValue !== undefined && !initilized) {
            handleNumberChange({ target: { value: defaultValue.toString() } } as React.ChangeEvent<HTMLInputElement>);
        }
    }, [defaultValue, initilized, handleNumberChange]);

    useEffect(() => {
        if (!initilized) {
            setInitilized(true)
            if (defaultValue) {
                handleNumberChange({ target: { value: defaultValue.toString() } } as React.ChangeEvent<HTMLInputElement>)
            }
        }
    }, [initilized, defaultValue, handleNumberChange])

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <input
                type="number"
                value={value}
                onChange={(e) => {
                    onValidityChange(e)
                    handleNumberChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
            />
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(NumberInput)

